import { createFileRoute } from "@tanstack/react-router";
import { serviceSchemaScripts } from "@/lib/service-schema";
import SeoEcommerceIA from "@/pages/servicios/SeoEcommerceIA";

export const Route = createFileRoute("/servicios/seo-ecommerce-ia")({
  head: () => ({
    meta: [
      { title: "SEO Ecommerce con IA + Exclusividad por Sector y Zona | SEOEVOLUTION" },
      { name: "description", content: "Compite por la dominancia en Google en tu sector ecommerce. IA para optimizar miles de productos, exclusividad por sector y zona blindada por contrato y resultados medidos en ventas. Solo 1 cliente por sector y zona." },
      { name: "keywords", content: "SEO ecommerce, posicionamiento tienda online, SEO con IA, optimización ecommerce, ventas online, SEO para tiendas online" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/servicios/seo-ecommerce-ia" },
      { property: "og:title", content: "SEO Ecommerce con IA + Exclusividad por Sector y Zona | SEOEVOLUTION" },
      { property: "og:description", content: "Compite por la dominancia en Google en tu sector ecommerce. IA para optimizar miles de productos y exclusividad por sector y zona." },
      { name: "twitter:title", content: "SEO Ecommerce con IA + Exclusividad por Sector y Zona | SEOEVOLUTION" },
      { name: "twitter:description", content: "Compite por la dominancia en Google en tu sector ecommerce. IA para optimizar miles de productos y exclusividad por sector y zona." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/servicios/seo-ecommerce-ia" }],
    scripts: serviceSchemaScripts("seo-ecommerce-ia"),
  }),
  component: SeoEcommerceIA,
});
